import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Start = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0918 7.16078C10.7179 7.10718 10.3364 7.16165 9.99247 7.31777C9.64851 7.47388 9.35638 7.72512 9.15056 8.04185C8.94474 8.35857 8.83378 8.72756 8.83083 9.10527V14.5318C8.82915 14.9118 8.93726 15.2842 9.14218 15.6042C9.34753 15.9249 9.64132 16.1793 9.98808 16.3367C10.3348 16.494 10.7197 16.5477 11.0963 16.4911C11.472 16.4347 11.8235 16.2709 12.1083 16.0196L12.1103 16.0179L15.6169 12.9534L15.6194 12.9511C15.779 12.8104 15.9068 12.6373 15.9944 12.4433C16.082 12.2493 16.1273 12.0389 16.1273 11.8261C16.1273 11.6133 16.082 11.4029 15.9944 11.209C15.9068 11.015 15.779 10.8419 15.6194 10.7011L12.1076 7.62448L12.1027 7.62027C11.8164 7.37382 11.4657 7.21439 11.0918 7.16078ZM10.8789 8.64561C10.7883 8.63261 10.6958 8.64582 10.6124 8.68366C10.529 8.72151 10.4582 8.78241 10.4083 8.8592C10.3588 8.93535 10.332 9.02396 10.3308 9.11474V14.5379C10.3303 14.6291 10.3562 14.7185 10.4054 14.7953C10.4546 14.8721 10.525 14.9331 10.608 14.9708C10.6911 15.0085 10.7833 15.0213 10.8735 15.0078C10.9637 14.9942 11.0481 14.9548 11.1164 14.8944L11.1198 14.8914L14.197 12.2022C14.4248 12.0031 14.425 11.6489 14.1974 11.4496L11.1221 8.75539C11.0531 8.69656 10.9687 8.65848 10.8789 8.64561Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.14331 11.8262C4.14331 7.58048 7.58512 4.13867 11.8308 4.13867C16.0765 4.13867 19.5183 7.58048 19.5183 11.8262C19.5183 16.0719 16.0765 19.5137 11.8308 19.5137C7.58512 19.5137 4.14331 16.0719 4.14331 11.8262ZM11.8308 2.63867C6.75669 2.63867 2.64331 6.75206 2.64331 11.8262C2.64331 16.9003 6.75669 21.0137 11.8308 21.0137C16.9049 21.0137 21.0183 16.9003 21.0183 11.8262C21.0183 6.75206 16.9049 2.63867 11.8308 2.63867Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
